import TabNavigation from "./components/TabNavigation";
import { useEffect, useState } from "react";
import BusinessDetailsTab from "./components/BusinessDetailsTab";
import AccountDetailsTab from "./components/AccountDetailsTab";
import SummaryTab from "./components/SummaryTab";
import UserDetailsTab from "./components/UserDetailsTab";
import { User, ShieldUser, BriefcaseBusiness, CircleAlert } from "lucide-react";
import { toast } from "react-toastify";
import { getSubscriptionPlans } from "services/subscriptionPlanService";


const SignUp = () => {
  const [registrationDetails, setRegistrationDetails] = useState({
    businessDetails: {
      name: '',
      contactNo:'',
      email:'',
      subscriptionId:'',
    },
    userDetails: {
      name: "",
      surname: "",
      contactNo: "",
      email: ""
    },
    accountDetails: {
      password: "",
      confirmPassword: ""
    },
    validation: {
      isBusinessDetailsValid: false,
      isAccountDetailsValid: false,
      isUserDetailsValid: false,
    },
  });
  const [activeTab, setActiveTab] = useState('user-details');
  const [subscriptionPlans, setSubscriptionPlans] = useState([]); 
  const [errorMessages, setErrorMessages] = useState([]);

  const resetErrorMessages = () => {
    setErrorMessages([]);
  };

  const addErrorMessages = (messages) => {
    setErrorMessages((prevMessages) => [...prevMessages, ...messages]);
  };

  const updateRegistrationDetails = (section, data, validationSection, validationStatus, nextTab) => {
    setRegistrationDetails((prevDetails) => ({
      ...prevDetails,
      [section]: { ...prevDetails[section], ...data },
      validation: {...prevDetails.validation, [validationSection]: validationStatus}
    }));

    if(validationStatus && nextTab)
      setActiveTab(nextTab);
  };

  const resetValidation = (validationSection, validationStatus) => {
    setRegistrationDetails((prevDetails) => ({
      ...prevDetails,
      validation: {...prevDetails.validation, [validationSection]: validationStatus}
    }));
  }

  const loadSubscriptionPlans = async () => {
    try {
      const response =  await getSubscriptionPlans();
      setSubscriptionPlans(response.data);
      //console.log("Subscription plans loaded:", response.data);
      console.log("Loaded subscription plans:", subscriptionPlans);
    } catch (error) {
      console.error("Failed to load subscription plans:", error);
      toast.error("Failed to load subscription plans. Please try again later.");
    }
  };

  const changeTab = (tabId) => {
    
    switch(tabId){
      case 'business-details':
        if(!registrationDetails.validation.isAccountDetailsValid){
          toast.error("Please complete the Account Details tab first.", {icon: <ShieldUser />});
          return;
        }
        break;
      case 'account-details':
        if(!registrationDetails.validation.isUserDetailsValid){
          toast.error("Please complete the User Details tab first.", {icon: <User />});
          return;
        }
        break;
      // case 'user-details':
      //   if(!registrationDetails.validation.isAccountDetailsValid){
      //     toast.error("Please complete the Account Details tab first.", {icon: <User />});
      //     return;
      //   }
      case 'summary-details':
        if(!registrationDetails.validation.isAccountDetailsValid){
          toast.error("Please complete the Account Details tab first.", {icon: <BriefcaseBusiness />});
          return;
        }
        break;
      default:
        break;
    }
    setActiveTab(tabId);
  }

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'business-details':
        return (
          <BusinessDetailsTab
            data={registrationDetails.businessDetails}
            validation={registrationDetails.validation.isBusinessDetailsValid}
            onSave={updateRegistrationDetails}
            onBack={() => changeTab('account-details')}
            subscriptionPlans={subscriptionPlans}
        
          />
        );
      case 'account-details':
        return (
          <AccountDetailsTab
            data={registrationDetails.accountDetails}
            username={registrationDetails.userDetails.email}
            validation={registrationDetails.validation.isAccountDetailsValid}
            onSave={updateRegistrationDetails}
            onBack={() => changeTab('user-details')}
          />
        );
      case 'user-details':
        return (
          <UserDetailsTab 
            data={registrationDetails.userDetails} 
            validation={registrationDetails.validation.isUserDetailsValid}
            onSave={updateRegistrationDetails}
         />
        );
      case 'summary-details':
        return (
          <SummaryTab 
            data={registrationDetails}
            onBack={() => changeTab('business-details')}
            subscriptionPlans={subscriptionPlans}
            onResetErrorMessage={resetErrorMessages}
            onAddErrorMessages={addErrorMessages}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if(subscriptionPlans.length === 0)
      loadSubscriptionPlans();
  },[]);

  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="mb-10">
        <h1 className="text-3xl font-bold mt-10">Sign Up</h1>
        <p className="mt-2 text-muted-foreground">Create your account to get started</p>
      </div>
      <TabNavigation activeTab={activeTab} onTabChange={changeTab} />
      {errorMessages.length > 0 && (
        <div role="alert" className="mt-2 mb-4 flex items-start gap-3 rounded-md border border-red-300 bg-red-50 p-4 text-red-800">
          <CircleAlert aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0" />
          <ul className="space-y-1 text-sm">
            {errorMessages.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        </div>
      )}
      <main className="w-full mt-4">
        {renderActiveTab()}
      </main>
    </div>
  );
};

export default SignUp;
